export const BASELINE_SCHEDULE_IMPERIAL = {
    'Oil Change': { miles: 5000, months: 6 },
    'Tire Rotation': { miles: 7500, months: 6 },
    'Air Filter': { miles: 15000, months: 12 },
    'Cabin Filter': { miles: 15000, months: 12 },
    'Brake Inspection': { miles: 12000, months: 12 },
    'Transmission Fluid': { miles: 30000, months: 24 },
    'Coolant Flush': { miles: 30000, months: 24 },
    'Spark Plugs': { miles: 30000, months: 36 },
    'Timing Belt': { miles: 60000, months: 48 },
    'Battery Check': { miles: 0, months: 12 },
    'Differential Fluid': { miles: 30000, months: 24 },
    'Power Steering Fluid': { miles: 50000, months: 36 },
};
/**
 * Metric baselines. The `miles` field still holds the count because the engine
 * is unit-agnostic — it compares `currentMileage` against interval distances
 * using whatever units the user stores. The field name is legacy.
 */
export const BASELINE_SCHEDULE_METRIC = {
    'Oil Change': { miles: 8000, months: 6 },
    'Tire Rotation': { miles: 12000, months: 6 },
    'Air Filter': { miles: 24000, months: 12 },
    'Cabin Filter': { miles: 24000, months: 12 },
    'Brake Inspection': { miles: 20000, months: 12 },
    'Transmission Fluid': { miles: 50000, months: 24 },
    'Coolant Flush': { miles: 50000, months: 24 },
    'Spark Plugs': { miles: 50000, months: 36 },
    'Timing Belt': { miles: 100000, months: 48 },
    'Battery Check': { miles: 0, months: 12 },
    'Differential Fluid': { miles: 50000, months: 24 },
    'Power Steering Fluid': { miles: 80000, months: 36 },
};
/** Kept as an alias for backward compatibility; callers that don't specify unit assume imperial. */
export const BASELINE_SCHEDULE = BASELINE_SCHEDULE_IMPERIAL;
export const BASELINE_SERVICE_TYPES = Object.keys(BASELINE_SCHEDULE_IMPERIAL);
export function getBaselineSchedule(unitSystem) {
    return unitSystem === 'metric' ? BASELINE_SCHEDULE_METRIC : BASELINE_SCHEDULE_IMPERIAL;
}
//# sourceMappingURL=baseline.js.map